import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, catchError, map, throwError } from 'rxjs';
import {
  InsuranceType,
  InsuranceTypeResponse,
  InsurancesTypeResponse,
} from './insurance-type.model';

@Injectable({
  providedIn: 'root',
})
export class InsuranceTypeService {
  readonly http = inject(HttpClient);
  path = 'insurance/insurance-type';

  private handleError(err: any, error: string) {
    return throwError(() =>
      err.status === 400 ? err.error.msg : `Se ha producido un error: ${error}`
    );
  }

  getList(): Observable<InsuranceType[]> {
    return this.http.get<InsurancesTypeResponse>(`${this.path}`).pipe(
      map(resp => resp.data),
      catchError(err => this.handleError(err, 'Recuperar elementos'))
    );
  }

  getInsurance(element_id: number): Observable<InsuranceType> {
    return this.http
      .get<InsuranceTypeResponse>(`${this.path}/${element_id}`)
      .pipe(
        map(resp => resp.data),
        catchError(err => this.handleError(err, 'Recuperar elemento'))
      );
  }

  // activeInsurance(type: number, id: number): Observable<boolean> {
  //   return this.http
  //     .post<boolean>(`${this.path}/${type}/item/${id}/active`, null)
  //     .pipe(catchError((err) => this.handleError(err, 'Activar elemento')));
  // }

  addInsurance(insurance: InsuranceType): Observable<InsuranceType> {
    return this.http
      .post<InsuranceType>(`${this.path}`, insurance)
      .pipe(catchError(err => this.handleError(err, 'Añadir elemento')));
  }

  modifyInsurance(insurance: InsuranceType): Observable<InsuranceType> {
    return this.http
      .put<InsuranceType>(
        `${this.path}/${insurance.insurance_type_id}`,
        insurance
      )
      .pipe(catchError(err => this.handleError(err, 'Modificar elemento')));
  }

  deleteInsurance(insurance_type_id: number): Observable<boolean> {
    return this.http
      .delete<boolean>(`${this.path}/${insurance_type_id}`)
      .pipe(catchError(err => this.handleError(err, 'Eliminar elemento')));
  }

  getPublicTypeList(): Observable<any> {
    // let params = new HttpParams().set('lang', lang);
    // params = params.set('all', true);
    return this.http.get<any>(`${this.path}/public`).pipe(
      map(resp => resp.data),
      catchError(err => this.handleError(err, 'Recuperar elementos'))
    );
  }
}
